// MarketHeader.jsx
// Modern header component with ISU branding

import React from 'react';
import { styles } from './styles';
import { UniversityIcon } from '../../components/Icons';

const MarketHeader = () => {
  return (
    <header style={styles.header}>
      <div style={styles.headerCard} className="header-card">
        {/* ISU Branding */}
        <div style={styles.brandSection}>
          <div style={styles.brandIcon}>
            <UniversityIcon size={28} color="white" />
          </div>
          <h1 style={styles.brandText} className="brand-text">Redbird Markets</h1>
        </div>
        
        {/* Main Title and Subtitle */}
        <h2 style={styles.title} className="market-title">Discover & Connect</h2>
        <p style={styles.subtitle} className="market-subtitle">
          Find amazing deals and unique items from your fellow Illinois State University Redbirds. 
          Buy, sell, and connect safely within our campus community.
        </p>
      </div>
    </header>
  );
};

export default MarketHeader;